import { RouteItem } from '@eastcoal/router/types/route'

export const coalZoneRoute: RouteItem = {
  title: '煤炭专区',
  path: '/coal',
  Component: () => import('./index')
}
